import {ACTION_TYPES, createAction} from "../actions";
import {call, put, takeEvery} from 'redux-saga/effects'
import {deleteEntityByFullUid} from "../../http/deleteEntityByFullUid";

export function* deleteEntitySaga () {
    yield takeEvery(ACTION_TYPES.DELETE_ENTITY, deleteEntityGenerator);
}
// export this generator
export function* deleteEntityGenerator(action: any) {
    const payload: {fullUid: string, type: string} = action.payload;
    try {
        const {fullUid, type} = payload;
        yield put(createAction(ACTION_TYPES.DELETE_ENTITY_SUCCESS, {
            fullUid, type
        }));
        yield call(deleteEntityByFullUid, fullUid);
        yield put(createAction(ACTION_TYPES.DELETE_ENTITY_SUCCESS, {
            fullUid, type
        }));
        yield put(createAction(ACTION_TYPES.SELECT_FEATURE, {feature: null}));
    } catch (error) {
        yield put(createAction(ACTION_TYPES.DELETE_ENTITY_ERROR, {error}));
    }
}
